import Vue from "vue";
import VueI18n from "vue-i18n";

const defaultLanguage = "en";
const localStorageLanguageKey = "lang";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /^\.\/[a-z]{2}.json$/s);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/^\.\/([a-z]{2}).json$/s);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const vueI18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || defaultLanguage,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || defaultLanguage,
  messages: loadLocaleMessages(),
});

vueI18n.locale = getLanguageFromLocalStorageOrDefault();

export function getLanguageFromLocalStorageOrDefault() {
  const languageFromLocalStorage = localStorage.getItem(localStorageLanguageKey);
  if (isSupportedLanguage(languageFromLocalStorage)) {
    return languageFromLocalStorage;
  }
  setLanguageToLocalStorage(defaultLanguage);
  return defaultLanguage;
}

export function isSupportedLanguage(language) {
  return vueI18n.availableLocales.includes(language);
}

export function setLanguageToLocalStorage(language) {
  if (isSupportedLanguage(language)) {
    localStorage.setItem(localStorageLanguageKey, language);
  } else {
    localStorage.setItem(localStorageLanguageKey, defaultLanguage);
  }
}

export default vueI18n;
